import { Component, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../../../shared/base-components/base.component';
import { VehicleSearchResult } from '../../../../vehicle/search/vehicle-search/vehicle-search-result.model';

@Component({
    selector: 'vehicle-generic-results',
    templateUrl: './vehicle-generic-results.html',
    inputs: ['results'],
    outputs: ['onVehicleSelected']
})
export class VehicleGenericResults extends BaseComponent {
    public results: VehicleSearchResult[] = [];
    public onVehicleSelected: EventEmitter<VehicleSearchResult> = new EventEmitter<VehicleSearchResult>();
    public cols = [
        { field: 'vehicleId', header: 'Vehicle Id' },
        { field: 'vehicleType', header: 'Vehicle Type' },
        { field: 'bodyStyle', header: 'Body Style' },
        { field: 'vin', header: 'VIN' },
        { field: 'year', header: 'Year' },
        { field: 'make', header: 'Make' },
        { field: 'model', header: 'Model' },
        { field: 'plateNumber', header: 'Plate #' },
        { field: 'registrationEndDate', header: 'Registration End Date' }
    ];

    constructor() {
        super();
    }

    public ngOnInit() {}

    public select(result: VehicleSearchResult) {
        this.onVehicleSelected.emit(result);
    }
}
